import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { talukaConfig } from '../config/index';
import { TalukaService } from '../../../../shared/services/TalukaService';

/**
 * TalukaDetail - URL-based detail page for Talukas
 * Handles view, edit, and add modes with ID from URL params
 */
export default function TalukaDetail() {
  return (
    <CRUDDetailPage
      config={talukaConfig}
      service={TalukaService}
    />
  );
}
